import { Box, Button, IconButton, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

type ComingSoonBannerProps = {
  onNotifyClick?: () => void;
};

const ComingSoonBanner = ({ onNotifyClick }: ComingSoonBannerProps) => {
  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (instituteData && instituteData.id) {
      getSubscriber(instituteData.id);
    }
  }, []);

  const getSubscriber = async (instituteId: string) => {
    try {
      setLoading(true);

      const apiKey = "MICO_NURTURE_BRIDGE_KEY";

      if (!apiKey) {
        throw new Error("API key is missing");
      }

      const response = await fetch(
        `https://vpvbphktncbjpinlzsex.supabase.co/functions/v1/record-launch-subscriber?institute_id=${instituteId}`,
        {
          method: "GET",
          headers: {
            "x-api-key": apiKey,
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Something went wrong");
      }

      setAlreadySubscribed(data.already_subscribed);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  console.log("instituteData", alreadySubscribed);
  const handleNotifyClick = async () => {
    const response = await fetch(
      "https://vpvbphktncbjpinlzsex.supabase.co/functions/v1/record-launch-subscriber",
      {
        method: "POST",
        headers: {
          "x-api-key": "MICO_NURTUE_BRIDGE_KEY",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          institute_id: instituteData.id,
          institute_name: instituteData.instituteName,
          email: instituteData.instituteEmail,
          phone: instituteData.instituteContact,
        }),
      },
    );

    const result = await response.json();
  };

  if (dismissed) {
    return null;
  }

  if (loading) {
    return null;
  }

  if (alreadySubscribed) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          width: "100%",
          boxSizing: "border-box",
          padding: "14px 24px",
          background: "#170f36",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              width: "40px",
              height: "40px",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #8b7cf6 0%, #7c6ee8 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <Typography
                sx={{
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: "15px",
                  lineHeight: 1.4,
                }}
              >
                Thank you
              </Typography>
              <Box
                sx={{
                  backgroundColor: "rgba(16, 185, 129, 0.15)",
                  color: "#6ee7b7",
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  padding: "3px 8px",
                  borderRadius: "999px",
                  textTransform: "uppercase",
                  lineHeight: 1,
                }}
              >
                Confirmed
              </Box>
            </Box>
            <Typography
              sx={{
                color: "rgba(233, 213, 255, 0.65)",
                fontSize: "13px",
                lineHeight: 1.4,
                whiteSpace: { xs: "normal", md: "nowrap" },
              }}
            >
              We&apos;ll notify you when Nurture OS launches.
            </Typography>
          </Box>
        </Box>

        <IconButton
          onClick={() => setDismissed(true)}
          sx={{
            flexShrink: 0,
            color: "rgba(255, 255, 255, 0.65)",
            "&:hover": {
              color: "#ffffff",
              backgroundColor: "rgba(255, 255, 255, 0.08)",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        width: "100%",
        boxSizing: "border-box",
        padding: "14px 24px",
        background:
          "radial-gradient(120% 180% at 100% 0%, #5b21b6 0%, #2a1454 45%, #1a0f30 100%)",
        flexWrap: "wrap",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: "14px", minWidth: 0 }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          ▲
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{
                color: "#ffffff",
                fontWeight: 600,
                fontSize: "15px",
                lineHeight: 1.4,
              }}
            >
              Something big is coming ✨
            </Typography>
            <Box
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                color: "#e9d5ff",
                fontSize: "10px",
                fontWeight: 700,
                letterSpacing: "0.5px",
                padding: "3px 8px",
                borderRadius: "999px",
                textTransform: "uppercase",
                lineHeight: 1,
              }}
            >
              Coming soon
            </Box>
          </Box>
          <Typography
            sx={{
              color: "rgba(233, 213, 255, 0.65)",
              fontSize: "13px",
              lineHeight: 1.4,
              whiteSpace: { xs: "normal", md: "nowrap" },
            }}
          >
            Nurture OS, our reimagined CRM experience, is launching soon. Stay
            tuned — you&apos;re going to love it.
          </Typography>
        </Box>
      </Box>

      <Button
        onClick={handleNotifyClick}
        sx={{
          flexShrink: 0,
          textTransform: "none",
          color: "#ffffff",
          border: "1px solid rgba(255, 255, 255, 0.4)",
          borderRadius: "8px",
          padding: "6px 16px",
          fontWeight: 600,
          fontSize: "14px",
          whiteSpace: "nowrap",
          "&:hover": {
            border: "1px solid rgba(255, 255, 255, 0.6)",
            backgroundColor: "rgba(255, 255, 255, 0.08)",
          },
        }}
      >
        Notify me at launch
      </Button>
    </Box>
  );
};

export default ComingSoonBanner;
